import { defineMessages, useIntl } from 'react-intl';
import { useEffect } from 'react';
import { SiteProperty } from 'volto-site-settings';
import LogoImage from '@plone/volto/components/theme/Logo/Logo.svg';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getNavroot } from '@plone/volto/actions';
import {
  flattenToAppURL,
  hasApiExpander,
  getBaseUrl,
} from '@plone/volto/helpers';

import { BrandText } from '@redturtle/volto-io-studio/components/Layout';

const BrandWrapper = ({ showBrandText = true, className, children }) => {
  const pathname = useLocation().pathname;
  const navroot = useSelector((state) => state.navroot.data);
  const dispatch = useDispatch();
  const intl = useIntl();

  const messages = defineMessages({
    home: {
      id: 'Home page',
      defaultMessage: 'Home page',
    },
    logo: {
      id: 'Logo',
      defaultMessage: 'Logo',
    },
  });

  useEffect(() => {
    if (pathname && !hasApiExpander('navroot', getBaseUrl(pathname))) {
      dispatch(getNavroot(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  const navRootPath = flattenToAppURL(navroot?.navroot?.['@id']) || '/';

  return (
    <div className={`brand-wrapper ${className ?? ''}`}>
      <div className="logo">
        <a href="/" aria-label={intl.formatMessage(messages.home)}>
          {children ?? (
            <SiteProperty
              property="site_logo"
              defaultValue={{ url: LogoImage, height: 58, width: 255 }}
              className="icon"
              alt={intl.formatMessage(messages.logo)}
            />
          )}
        </a>
      </div>
      {showBrandText && (
        <div className="brand-text-wrapper">
          <a href={navRootPath} aria-label={intl.formatMessage(messages.home)}>
            <BrandText />
          </a>
        </div>
      )}
    </div>
  );
};

export default BrandWrapper;
